import {
    AppBar,
    //Button,
    CircularProgress,
    createStyles,
    //Fab,
    Grid,
    Theme,
    Toolbar,
    WithStyles,
    withStyles,
} from "@material-ui/core";
//import { Sensors } from "@material-ui/icons";
import SwiperCore from "@theankur/swiper/core";
import "@theankur/swiper/swiper.scss";
import firebase from "firebase";
import { parse } from "query-string";
import React, { SyntheticEvent } from "react";
import { connect, ConnectedProps } from "react-redux";
import { setReqHeaderXAppName } from "shared/src/framework/network/headers";
import { Analytic } from "./analytic/analytic";
import { withRouter, WithRouterProps } from "./hoc/withRouter";
import { OneSignal } from "./integrations/one-signal/one-signal";
import { BottomNavigationValues, setBottomNavigation } from "./redux/app/AppSlice";
import { RootState } from "./redux/store";
import { commonClasses } from "./styles";

const styles = (theme: Theme) =>
    createStyles({
        ...commonClasses,
        logo: {
            height: "18px",
            objectFit: "contain",
        },
        bottomNavigation: {
            height: "56px",
            zIndex: 1,
            position: "fixed",
            right: 0,
            bottom: 0,
            left: 0,
            "& .MuiBottomNavigation-root": {
                marginTop: "4px",
            },
        },
        bottomNavActionIcon: {
            width: "32px",
            height: "32px",
        },
        bottomNavAction: {
            color: "rgba(0, 0, 0, 0.6)",
            "& .MuiSvgIcon-root": { width: "32px", height: "32px" },
            "&.Mui-selected": {
                "& .MuiSvgIcon-root": {
                    backgroundImage: "linear-gradient(#2B85A1, #18586C)",
                    color: "#fff",
                    borderRadius: "50%",
                },
                "& .MuiBottomNavigationAction-label": {
                    color: "#1785a0",
                    fontWeight: "bold",
                },
            },
            "& .MuiBadge-badge": {
                margin: "7px 0px 1px -16px",
                backgroundColor: "#b60a00",
                fontSize: "11px",
                paddingLeft: "11px",
                paddingRight: "11px",
                paddingBottom: "3px",
            },
        },
        header: {
            backgroundColor: "#FFF",
            position: "relative",
            zIndex: 2,
        },
        toolbar: {
            minHeight: "32px",
        },
        addPollButton: {
            top: 194,
            zIndex: 1,
        },
        addImage: {
            borderRadius: "50%",
            display: "block",
            cursor: "pointer",
            right: "18px",
            width: "18px",
        },
        livePollIcon: {
            color: "#ff0000",
            "& .MuiSvgIcon-root": {
                fontSize: "14px",
                marginRight: "5px",
            },
        },
    });

const mapState = (state: RootState) => ({
    activeBottomNavigation: state.app.activeBottomNavigation,
});

const mapDispatch = {
    setBottomNavigation,
};

const connector = connect(mapState, mapDispatch);

type Props = WithStyles<typeof styles> & ConnectedProps<typeof connector> & WithRouterProps;

type State = {
    isLoadingAuth: boolean;
};

class Component extends React.Component<Props, State> {
    swiper?: SwiperCore;
    unsubscribeAuthStateObserver?: firebase.Unsubscribe;
    availableWidth = window.innerWidth < 600 ? window.innerWidth : 600;
    availableHeight = window.innerHeight - (window.innerWidth < 600 ? 56 : 64);
    slideLoaded: Array<number>;
    isSliderInit: boolean;
    constructor(props: Props) {
        super(props);
        this.state = {
            isLoadingAuth: true,
        };
        Analytic.setTabIndex("poll");
        this.slideLoaded = [0];
        this.isSliderInit = false;
        setReqHeaderXAppName("web");
    }

    componentDidUpdate = (prevProps: Props, prevState: State) => {
        const { activeBottomNavigation } = this.props;
        if (prevProps.activeBottomNavigation !== activeBottomNavigation) {
            const index = this.getIndexByBottomNavigationValue(activeBottomNavigation);
            if (this.swiper?.activeIndex !== index) {
                this.swiper?.slideTo(index);
            }
        }
    };

    componentDidMount = async () => {
        this.swiper?.update();
        // const userId = getGlobalUserId();
        // if (!userId) {
        //     this.unsubscribeAuthStateObserver = firebase.auth().onAuthStateChanged((user) => {
        //         const userId = user?.uid;

        //         userAdd({ userId }).then((res) => {
        //             setGlobalAuthToken(res.token);
        //             setGlobalUserId(res.userId);
        //             Analytic.setUserId(res.userId);
        //             this.setState({ isLoadingAuth: false });
        //         });
        //     });
        // } else {
        //     Analytic.setUserId(userId);
        //     this.setState({ isLoadingAuth: false });
        // }

        window.addEventListener("resize", this.handleWindowResize);
    };
    getIsFromNotificationFromQueryParams = () => {
        const queryStringParams = parse(window.location.search);
        return !!queryStringParams.notification;
    };
    componentWillUnmount = () => {
        this.unsubscribeAuthStateObserver?.();
        window.removeEventListener("resize", this.handleWindowResize);
    };

    handleWindowResize = () => {
        if (window.innerHeight > this.availableHeight) {
            this.swiper?.el.scroll({ top: 0 });
        }
    };

    handleBottomNavigationChange = (event: SyntheticEvent, newValue: BottomNavigationValues) => {
        const { setBottomNavigation } = this.props;
        if (!!this.swiper) {
            // ask for notification on create tab click.
            if (newValue === "create") {
                OneSignal.init("Never miss an update on your poll. No spam - we promise.");
            }
            const tabIndex =
                newValue === "whatsApp"
                    ? this.swiper.activeIndex
                    : this.getIndexByBottomNavigationValue(newValue);
            setBottomNavigation(newValue);
            this.swiper?.slideTo(tabIndex);
        }
    };

    getIndexByBottomNavigationValue = (value: BottomNavigationValues) => {
        return value === "create" ? 0 : value === "polls" ? 1 : 2;
    };

    setBottomNavigationByIndex = (index: number) => {
        const { setBottomNavigation } = this.props;
        setBottomNavigation(index === 0 ? "create" : index === 1 ? "polls" : "whatsApp");
    };

    handleSwiperInit = (swiper: SwiperCore) => {
        this.swiper = swiper;
        swiper.update();
        this.isSliderInit = true;

        if (this.getIsFromNotificationFromQueryParams()) {
            this.swiper?.slideTo(0);
        }
    };

    handleSlideChange = (swiper: SwiperCore) => {
        if (!this.slideLoaded.includes(swiper.activeIndex)) {
            this.slideLoaded.push(swiper.activeIndex);
        }
        const preActiveTab =
            swiper.previousIndex === 0
                ? "Create"
                : swiper.previousIndex === 1
                ? "poll"
                : "WhatsApp";
        const activeTab =
            swiper.activeIndex === 0 ? "Create" : swiper.activeIndex === 1 ? "poll" : "WhatsApp";
        if (this.isSliderInit) {
            Analytic.setTabIndex(activeTab);
            Analytic.addEvent({
                event: "tab_swipe",
                previousTab: preActiveTab,
                swipeType: swiper.previousIndex > swiper.activeIndex ? "Left" : "Right",
                defaultGTMConfig: "false",
            });
        }
        this.setBottomNavigationByIndex(swiper.activeIndex);
    };

    loadSlide = (children: JSX.Element, index: number) => {
        if (this.slideLoaded.includes(index)) {
            return children;
        }
        return (
            <Grid
                container
                className={this.props.classes.fullHeight}
                alignItems="center"
                justifyContent="center">
                <CircularProgress />
            </Grid>
        );
    };

    handleLogoClick = () => {
        const { setBottomNavigation } = this.props;
        setBottomNavigation("polls");
        this.swiper?.slideTo(1);
    };

    handleTabButtonClick = () => {
        const { activeBottomNavigation } = this.props;
        const bottomNavigationValue = this.getIndexByBottomNavigationValue(activeBottomNavigation);
        if (bottomNavigationValue !== 1) {
            this.setBottomNavigationByIndex(1);
            this.swiper?.slideTo(1);
            this.props.navigate("/");
        } else if (bottomNavigationValue === 1) {
            this.setBottomNavigationByIndex(0);
            this.swiper?.slideTo(0);
            this.props.navigate("/create-flash");
        }
    };

    render = () => {
        const { classes } = this.props;
        // const { isLoadingAuth } = this.state;
        // const bottomNavigationValue = this.getIndexByBottomNavigationValue(activeBottomNavigation);
        // if (isLoadingAuth) {
        //     return (
        //         <Grid
        //             container
        //             className={classes.fullHeight}
        //             alignItems="center"
        //             justifyContent="center">
        //             <CircularProgress />
        //         </Grid>
        //     );
        // }
        return (
            // <SocketProvider host={process.env.REACT_APP_WS_HOST}>
            <AppBar elevation={0} position="static" className={classes.header}>
                <Toolbar className={classes.toolbar}>
                    <Grid container justifyContent="center">
                        <Grid item>
                            <img
                                className={classes.logo}
                                alt="logo"
                                id={"btn-logo"}
                                data-event="logo_click"
                                src={
                                    process.env.PUBLIC_URL +
                                    "/images/logo-0813d909d3ba4dff7f66a64f88ee00de.png"
                                }
                                onClick={this.handleLogoClick}
                            />
                        </Grid>
                    </Grid>
                </Toolbar>
            </AppBar>
            // </SocketProvider>
        );
    };
}

const BeforeWithRouter = withStyles(styles)(Component);
const Main = withRouter(BeforeWithRouter);

export default connector(Main);
